import ItemListPage from "./ItemListPage";

export default function Completed() {
  return (
    <ItemListPage titleKey="nav.completed" subtitleKey="dashboard.completedSubtitle" testid="completed-page" status="completed" />
  );
}
